import {
   Box,
   Button,
   FormControl,
   Grid,
   InputLabel,
   MenuItem,
   Paper,
   Radio,
   Select,
   Typography
} from '@material-ui/core'
import Pagination from '@material-ui/lab/Pagination'
import { useState, useEffect } from 'react'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import ArrowForwardIcon from '@material-ui/icons/ArrowForward'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import isEqual from 'lodash/isEqual'
import { useHistory } from 'react-router-dom'

import PortalModal, { usePortalModal } from 'components/commons/PortalModal'
import SuccesQues from './SuccesQues'
import MediumQues from './MediumQues'
import FailQues from './FailQues'
import UserProgressBar from 'components/Questionnaire/UserProgressBar'

import homeIcon from 'images/components/reporter/HomeIcon.svg'
import previewQuestionnaireStyles from './styles'
import { useStateValue } from 'context/store'
import { userSettingsModule } from 'utils/utils'
import { QUESTIONNAIRE } from './constants'
import { Controller, useFieldArray, useForm } from 'react-hook-form'
import { getFromApi, putToApi } from 'actions'
import { openSnackBarAction } from 'context/reducers/openSnackbarReducer'
import { ContactSupportOutlined } from '@material-ui/icons'

const editPermission = userSettingsModule.buscarValorEnUserSettings(
   'operations',
   'EDITAR CUESTIONARIO'
)

function PreviewQuestionnaire() {
   const [currenQuestion, setCurrentQuestion] = useState(1)
   const [{ questionaries }, dispatch] = useStateValue()
   const [totalQuestions, setTotalQuestions] = useState(1)
   const [dataQues, setDataQues] = useState([])
   const [number, setNumber] = useState(1)
   const [name, setName] = useState('')
   const [questionid, setQuestionid] = useState('')
   const [evaluateUserId, setEvaluateUserId] = useState('')
   const [currentDataQuestions, setCurrentDataQuestions] = useState([])
   const { params, onClose, setModal } = usePortalModal()
   const [page, setPage] = useState(1)

   const [score, setScore] = useState(null)

   const handleChangePage = (event, value) => {
      const form = getValues('question')
      console.log(form)
      let hayElementoNoNull = true
      const index = value - 2 > 0 ? value - 2 : 0
      if (Array.isArray(form[index])) {
         if (form[index].length == 0) {
            return
         }
      }
      if (!form[index]) {
         return
      }
      setNumber(number + 1)
      sendForm()
      setPage(value)
      setCurrentQuestion(value)
   }

   const history = useHistory()
   const {
      register,
      control,
      handleSubmit,
      reset,
      trigger,
      setError,
      getValues
   } = useForm({
      // defaultValues: {}; you can populate the fields by this attribute
   })
   const getParams = () => {
      const queryString = history.location.search
      const params = new URLSearchParams(queryString)
      const id = params.get('id')
      setName(params.get('name'))
      setEvaluateUserId(params.get('attempId'))
      const numero = id ? parseInt(id, 10) : null
      setQuestionid(numero)
      return numero
   }
   const { fields, remove, update } = useFieldArray({
      control,
      name: 'question'
   })

   const validQues = () => {
      const form = getValues('question')
      console.log(form)
   }
   const ITEMS_PER_QUESTION = 1
   const sortArrayByNumber = arr => {
      arr?.sort((a, b) => a?.number - b?.number)
      return arr
   }

   const mapQuestions = questionary => {
      if (questionary?.questions?.length) {
         setTotalQuestions(
            Math.ceil(questionary.questions.length / ITEMS_PER_QUESTION)
         )
         const questions = sortArrayByNumber(questionary?.questions)
         setDataQues(questions)

         setCurrentDataQuestions(questions.slice(0, ITEMS_PER_QUESTION))
      }
   }
   const goToMundoMutual = () => {
      if (currenQuestion != totalQuestions) {
         const message =
            'Señor usuario,  usted intenta ir a la página principal de Mundo Mutual, esta acción envía las respuestas diligenciadas hasta el momento del cuestionario y obtendrá una nota ¿Desea continuar?'
         setModal({ message, onConfirm: handleNext })
         return
      }
      history.push('/dashboard/mutual-world?show=true')
      dispatch({ type: 'reset' })
   }
   const handleNext = () => {
      history.push('/dashboard/mutual-world?show=true')
      dispatch({ type: 'reset' })
   }
   const handlePrev = () => {
      history.push('/dashboard/mutual-world?show=true')
   }
   const goToMundoBack = () => {
      if (currenQuestion != totalQuestions) {
         const message =
            'Señor usuario,  usted intenta ir a la vista de videos, esta acción envía las respuestas diligenciadas hasta el momento del cuestionario y obtendrá una nota ¿Desea continuar?'
         setModal({ message, onConfirm: handlePrev })
         return
      }
      history.push('/dashboard/mutual-world?show=true')
   }
   const validSendForm = () => {
      if (currenQuestion != totalQuestions) {
         const message =
            'Señor usuario,  usted intenta finalizar el cuestionario sin haber respondido todas las preguntas, esta acción envía las respuestas diligenciadas hasta el momento del cuestionario y obtendrá una nota ¿Desea continuar?'
         setModal({ message, onConfirm: finalizarForm })
         return
      }
      finalizarForm()
   }
   const finalizarForm = async () => {
      const form = getValues('question')
      const index = currenQuestion - 1
      let dataRes = form[index]
      if (!Array.isArray(form[index])) {
         dataRes = [parseInt(form[index])]
      }
      const payload = {
         evaluateUserId: parseInt(evaluateUserId),
         questionId: currentDataQuestions[0].id,
         answerIds: dataRes
      }
      try {
         const URL_QUESTIONNARIE = `${process.env.REACT_APP_QUESTIONNAIRE_API}/evaluate-user`
         const URL_QUESTIONNARIEND = `${
            process.env.REACT_APP_QUESTIONNAIRE_API
         }/evaluate-user/result/${parseInt(evaluateUserId)}`
         console.log(dataRes)
         if (dataRes[0]) {
            const dataPost = await putToApi(URL_QUESTIONNARIE, payload)
         }
         const dataGet = await getFromApi(URL_QUESTIONNARIEND)
         console.log(dataGet)
         setScore(dataGet)
      } catch (error) {
         console.error('Error fetching questionnaire data:', error)
         dispatch(openSnackBarAction(error?.data?.message))
      }
   }
   const sendForm = async () => {
      const form = getValues('question')
      const index = currenQuestion - 1
      let dataRes = form[index]
      if (Array.isArray(form[index])) {
         if (form[index].length == 0) {
            return
         }
      }
      if (!form[index]) {
         return
      }
      if (!Array.isArray(form[index])) {
         dataRes = [parseInt(form[index])]
      }
      const payload = {
         evaluateUserId: parseInt(evaluateUserId),
         questionId: currentDataQuestions[0].id,
         answerIds: dataRes
      }
      try {
         const URL_QUESTIONNARIE = `${process.env.REACT_APP_QUESTIONNAIRE_API}/evaluate-user`
         const dataPost = await putToApi(URL_QUESTIONNARIE, payload)
      } catch (error) {
         console.error('Error fetching questionnaire data:', error)
         dispatch(openSnackBarAction(error?.data?.message))
      }
   }
   const getDataQuestionnaire = async id => {
      try {
         const url = `${process.env.REACT_APP_QUESTIONNAIRE_API}/questionnaire/${id}`
         const ques = await getFromApi(url)
         mapQuestions(ques)
         dispatch({
            type: 'SaveQuest',
            questionaries: { ...ques, previewMode: true }
         })
      } catch (error) {
         console.error('Error fetching questionnaire data:', error)
      }
      dispatch({ type: 'CLOSE_SPINNER' })
   }
   const classes = previewQuestionnaireStyles()

   const [selectedValue, setSelectedValue] = useState()

   const handleChange = event => {
      setSelectedValue(event.target.value)
   }

   const controlProps = item => ({
      checked: selectedValue == item,
      onChange: handleChange,
      value: item,
      name: 'color-radio-button-demo',
      inputProps: { 'aria-label': item }
   })
   const ListOption = ({ indexForm }) => (
      <Box
         className={classes.containForm}
         sx={{
            display: 'flex',
            flexDirection: 'column',
            // justifyContent: 'center',
            alignContent: 'center',
            width: '94%',
            gap: '1rem',
            marginBottom: '3rem'
            // padding: '2rem 0'
         }}
      >
         <FormControl
            variant="outlined"
            className={classes.formControlSelect}
            fullWidth
         >
            <InputLabel id="demo-s imple-select-label">
               Seleccionar tu respuesta
            </InputLabel>
            <Controller
               name={`question.${currenQuestion - 1}`}
               id="level"
               control={control}
               render={({ field }) => (
                  <Select
                     {...field}
                     InputProps={{
                        classes: {
                           input: classes.root
                        }
                     }}
                     className={classes.selectInput}
                     MenuProps={{ classes: { list: classes.list } }}
                     variant="outlined"
                     label="Seleccionar un formato"
                     // value={value}
                     // onChange={onChange}
                     fullWidth
                     classes={{
                        root: classes.root,
                        option: classes.option
                     }}
                  >
                     {currentDataQuestions[0].answers.map((question, index) => (
                        <MenuItem
                           key={question.id}
                           value={question.id}
                           className={classes.boxItemSelect}
                        >
                           <CheckCircleIcon />
                           {question.valueAnswer}
                        </MenuItem>
                     ))}
                  </Select>
               )}
            />
         </FormControl>
      </Box>
   )

   const SingleOption = ({ indexForm }) => (
      <Box
         className={classes.containForm}
         sx={{
            display: 'flex',
            flexDirection: 'column',
            // justifyContent: 'center',
            alignContent: 'center',
            width: '94%',
            gap: '1rem',
            marginBottom: '3rem'
            // padding: '2rem 0'
         }}
      >
         {currentDataQuestions[0].answers.map((question, index) => (
            <label
               key={question.id || question.idVista}
               className={classes.itemAsnwerBox}
            >
               <Controller
                  render={({ field }) => (
                     <Radio
                        {...field}
                        color="primary"
                        value={question.id}
                        checked={field.value == question.id}
                     />
                  )}
                  name={`question.${currenQuestion - 1}`}
                  control={control}
                  defaultValue={false}
               />
               <p>{question.valueAnswer}</p>
            </label>
         ))}
      </Box>
   )

   const MultipleOption = () => (
      <Box
         className={classes.containForm}
         sx={{
            display: 'flex',
            flexDirection: 'column',
            width: '94%',
            gap: '1rem',
            marginBottom: '3rem'
         }}
      >
         {currentDataQuestions[0].answers.map(answer => (
            <Controller
               key={answer.id || answer.idVista}
               control={control}
               name={`question.${currenQuestion - 1}`}
               render={({ field: { onChange, onBlur, value, ref } }) => (
                  <label className={classes.itemAsnwerBox}>
                     <input
                        type="checkbox"
                        onChange={e => {
                           const selectedId = answer.id || answer.idVista

                           const selectedIds = Array.isArray(value)
                              ? [...value]
                              : []

                           onChange(
                              e.target.checked
                                 ? [...selectedIds, selectedId]
                                 : selectedIds.filter(id => id !== selectedId)
                           )
                        }}
                        onBlur={onBlur}
                        checked={
                           Array.isArray(value) &&
                           value.includes(answer.id || answer.idVista)
                        }
                     />
                     <p>{answer.valueAnswer}</p>
                  </label>
               )}
            />
         ))}
      </Box>
   )

   useEffect(() => {
      dispatch({ type: 'OPEN_SPINNER' })
      const res = getParams()
      const fetchData = async () => {
         await getDataQuestionnaire(res)
      }
      fetchData()
   }, [])

   useEffect(() => {
      const begin = (currenQuestion - 1) * ITEMS_PER_QUESTION
      const end = begin + ITEMS_PER_QUESTION
      setCurrentDataQuestions(dataQues.slice(begin, end))
   }, [currenQuestion, dataQues])
   useEffect(() => {
      isEqual(questionaries?.publishState, QUESTIONNAIRE.PUBLISHED_STATUS)
      // setViewQuestionnarie('view-search-questionnaire')
   }, [questionaries])
   return (
      <div className={classes.container}>
         <div className={classes.buttonsNavigationsBox}>
            <div
               className={classes.buttonHome}
               onClick={() => goToMundoMutual()}
            >
               <img
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                  src={homeIcon}
                  alt={'Inicio'}
               />
            </div>
            <div
               className={classes.iconArrowBack}
               onClick={() => goToMundoBack()}
            >
               <ArrowBackIcon />
            </div>
         </div>
         <h2 className={classes.title}>Quiz / {name}</h2>
         {score?.message == '¡Felicitaciones! Puntuación perfecta.' ? (
            <SuccesQues score={score} />
         ) : score?.message == '¡Felicitaciones!' ? (
            <MediumQues score={score} />
         ) : score?.message == '¡Upps!' ? (
            <FailQues score={score} />
         ) : (
            <Paper className={classes.paper}>
               <div className={classes.boxLineDecoration}>
                  <div style={{ backgroundColor: '#71BE4A', width: '10%' }} />
                  <div style={{ backgroundColor: '#0098DF', width: '10%' }} />
               </div>
               <Grid style={{ width: '100%', margin: '0', padding: '0' }}>
                  <div className={classes.boxInfo}>
                     <h4>{questionaries?.questionaries?.name}</h4>
                     <p>{questionaries?.questionaries?.description}</p>
                  </div>
               </Grid>
               <form className={classes.form}>
                  <Box
                     className={classes.containForm}
                     sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignContent: 'center',
                        margin: '2rem 0 1rem 0',
                        width: '94%'
                        // padding: '2rem 0'
                     }}
                  >
                     <h3
                        style={{
                           margin: '4px 0 0 0',
                           padding: '0'
                        }}
                     >
                        {currenQuestion}. {currentDataQuestions[0]?.question}
                     </h3>
                  </Box>

                  {currentDataQuestions?.map((question, index) => {
                     if (
                        question.questionType?.id === 3 ||
                        question.questionType?.idVista === 3
                     ) {
                        return <ListOption indexForm={index} key={index} />
                     }
                     if (
                        question.questionType?.id === 1 ||
                        question.questionType?.idVista === 3
                     ) {
                        return <SingleOption indexForm={index} key={index} />
                     }
                     if (
                        question.questionType?.id === 2 ||
                        question.questionType?.idVista === 3
                     ) {
                        return <MultipleOption indexForm={index} key={index} />
                     }
                  })}

                  <Box
                     className={classes.containForm}
                     sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignContent: 'center',
                        height: '70px',
                        width: '100%',
                        marginTop: '2rem',
                        background: '#A7B0C61A 0% 0% no-repeat'
                     }}
                  >
                     <div className={classes.boxFooterPaper}>
                        <div />
                        <Pagination
                           color="primary"
                           count={totalQuestions}
                           page={page}
                           onChange={handleChangePage}
                        />
                        <Button
                           className={classes.buttonReadyAnswer}
                           size="large"
                           variant="contained"
                           color="primary"
                           onClick={() => validSendForm()}
                        >
                           Finalizar
                        </Button>
                     </div>
                  </Box>
               </form>
               <PortalModal params={params} onClose={onClose} />
            </Paper>
         )}
         <UserProgressBar
            Menu={
               <QuestSummary summary={questionaries?.questSummary?.summary} />
            }
         />
      </div>
   )
}

const QuestSummary = ({ summary }) => {
   const { numberAttempts = '-', percentage = '-', score = '-' } = summary || {}
   return (
      <Grid container wrap="nowrap" alignItems="center">
         <Grid
            item
            style={{
               borderRadius: '50%',
               background: 'linear-gradient(to right, #144787, #0d5fa1)',
               margin: '1px 10px 0 0',
               padding: '9px 7px 3px 9px'
            }}
         >
            <ContactSupportOutlined htmlColor="#fff" style={{ fontSize: 45 }} />
         </Grid>
         <Grid
            container
            direction="column"
            wrap="nowrap"
            style={{ margin: '5px' }}
         >
            <Typography variant="caption">
               <b>CUESTIONARIO</b>
            </Typography>
            <Typography
               variant="caption"
               style={{ fontSize: 11, whiteSpace: 'nowrap' }}
            >
               Cantidad de intentos <b>{numberAttempts}</b>
            </Typography>
            <Typography
               variant="caption"
               style={{ fontSize: 11, whiteSpace: 'nowrap' }}
            >
               Porcentaje de cumplimiento <b>{percentage}%</b>
            </Typography>
            <Typography
               variant="caption"
               style={{ fontSize: 11, whiteSpace: 'nowrap' }}
            >
               Puntaje del cuestionario <b>{score}</b>
            </Typography>
         </Grid>
      </Grid>
   )
}

export default PreviewQuestionnaire
